import type { FC } from 'react'

import { Label as LabelPrimitive } from '@/components/ui/label'

interface LabelProps {
	label: string
	description: string
	htmlFor?: string
}
export const Label: FC<LabelProps> = ({ label, description, htmlFor }) => (
	<div>
		<LabelPrimitive htmlFor={htmlFor} className="text-base font-medium">
			{label}
		</LabelPrimitive>
		<p className="text-sm text-secondary-foreground">{description}</p>
	</div>
)
